export const MaterialIcon = ({ name, className = "" }) => {
  return (
    <span className={`material-icons ${className}`}>
      {name}
    </span>
  );
};